// 定义幂次常量
const LOG_POWER = 6;

// 预计算的底数及其LOG_POWER次方值（按底数从小到大排序）
const basePowerTable: {base: number, power: number}[] = [
  {base: 1.001, power: Math.pow(1.001, LOG_POWER)},
  {base: 1.003, power: Math.pow(1.003, LOG_POWER)},
  {base: 1.005, power: Math.pow(1.005, LOG_POWER)},
  {base: 1.01, power: Math.pow(1.01, LOG_POWER)},
  {base: 1.03, power: Math.pow(1.03, LOG_POWER)},
  // 1.05-1.95 (0.05步进)
  {base: 1.05, power: Math.pow(1.05, LOG_POWER)},
  {base: 1.10, power: Math.pow(1.10, LOG_POWER)},
  {base: 1.15, power: Math.pow(1.15, LOG_POWER)},
  {base: 1.20, power: Math.pow(1.20, LOG_POWER)},
  {base: 1.25, power: Math.pow(1.25, LOG_POWER)},
  {base: 1.30, power: Math.pow(1.30, LOG_POWER)},
  {base: 1.35, power: Math.pow(1.35, LOG_POWER)},
  {base: 1.40, power: Math.pow(1.40, LOG_POWER)},
  {base: 1.45, power: Math.pow(1.45, LOG_POWER)},
  {base: 1.50, power: Math.pow(1.50, LOG_POWER)},
  {base: 1.55, power: Math.pow(1.55, LOG_POWER)},
  {base: 1.60, power: Math.pow(1.60, LOG_POWER)},
  {base: 1.65, power: Math.pow(1.65, LOG_POWER)},
  {base: 1.70, power: Math.pow(1.70, LOG_POWER)},
  {base: 1.75, power: Math.pow(1.75, LOG_POWER)},
  {base: 1.80, power: Math.pow(1.80, LOG_POWER)},
  {base: 1.85, power: Math.pow(1.85, LOG_POWER)},
  {base: 1.90, power: Math.pow(1.90, LOG_POWER)},
  {base: 1.95, power: Math.pow(1.95, LOG_POWER)},
  
  // 2-10 (0.5步进)
  {base: 2.0, power: Math.pow(2.0, LOG_POWER)},
  {base: 2.5, power: Math.pow(2.5, LOG_POWER)},
  {base: 3.0, power: Math.pow(3.0, LOG_POWER)},
  {base: 3.5, power: Math.pow(3.5, LOG_POWER)},
  {base: 4.0, power: Math.pow(4.0, LOG_POWER)},
  {base: 4.5, power: Math.pow(4.5, LOG_POWER)},
  {base: 5.0, power: Math.pow(5.0, LOG_POWER)},
  {base: 5.5, power: Math.pow(5.5, LOG_POWER)},
  {base: 6.0, power: Math.pow(6.0, LOG_POWER)},
  {base: 6.5, power: Math.pow(6.5, LOG_POWER)},
  {base: 7.0, power: Math.pow(7.0, LOG_POWER)},
  {base: 7.5, power: Math.pow(7.5, LOG_POWER)},
  {base: 8.0, power: Math.pow(8.0, LOG_POWER)},
  {base: 8.5, power: Math.pow(8.5, LOG_POWER)},
  {base: 9.0, power: Math.pow(9.0, LOG_POWER)},
  {base: 9.5, power: Math.pow(9.5, LOG_POWER)},
  {base: 10.0, power: Math.pow(10.0, LOG_POWER)}
].sort((a, b) => a.base - b.base); // 确保按底数排序

/**
* 选择刚好使base^LOG_POWER大于比率的最小底数
* @param minValue 数据最小值
* @param maxValue 数据最大值
* @returns 推荐的对数底数
*/
export function selectLogBase(minValue: number, maxValue: number): number {
  if (minValue <= 0 || maxValue <= 0) {
      return Math.E; // 对于非正数数据，返回自然对数底数
  }
  
  const ratio = maxValue / minValue;
  
  // 寻找第一个使base^LOG_POWER > ratio的底数
  for (const entry of basePowerTable) {
      if (entry.power > ratio) {
          return entry.base;
      }
  }
  
  // 如果所有底数都不够大，返回最大底数
  return basePowerTable[basePowerTable.length - 1].base;
}
